// src/components/pages/Pessoa/modules/usePessoaImagemModule.js

import { useState } from 'react';

export function usePessoaImagemModule({ dados, setDados }) {
    const [preview, setPreview] = useState([]);

    function onFileChange(e) {
        const files = Array.from(e.target.files || []);
        setPreview(files);

        setDados((prev) => ({
            ...prev,
            images: files,
        }));
    }

    function limparImagem() {
        setPreview([]);

        setDados((prev) => ({
            ...prev,
            images: null,
        }));
    }

    return {
        state: {
            preview,
        },
        actions: {
            onFileChange,
            limparImagem,
        },
    };
}
